class ExtendSectionS2 extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS2] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    this._resizeEffects = [_safeInit(() => this.initUseCases())].filter(
      Boolean
    );
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  onResize() {
    super.onResize();
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  // 【使用事例】的特效
  initUseCases() {
    const useCasesEl = document.querySelector(".extend-s2-use-cases");
    if (!useCasesEl) return null;
    const cases = useCasesEl.querySelectorAll(".es2uc__case");
    const images = useCasesEl.querySelectorAll(".es2uc__case-image");
    const imagesContainer = useCasesEl.querySelector(".es2uc__case-images");
    const imagesInner = useCasesEl.querySelector(".es2uc__case-images-inner");
    let activeIndex = 0;

    function goTo(index) {
      const imagesContainerHeight = imagesContainer.offsetHeight;
      cases.forEach((c) => c.classList.remove("is-active"));
      images.forEach((img) => img.classList.remove("is-active"));
      cases[index].classList.add("is-active");
      images[index].classList.add("is-active");
      const offset = (imagesContainerHeight + 10) * index;
      imagesInner.style.transform = `translateY(${-offset}px)`;
      activeIndex = index;
    }

    cases.forEach((item) => {
      item.addEventListener("click", () => {
        goTo(Number(item.dataset.index));
      });
    });

    return function onResize() {
      goTo(activeIndex);
    };
  }
}
